import React from 'react';
import PropTypes from 'prop-types';
import styles from './FilterLogicToggle.module.css';

const FilterLogicToggle = ({ value, onChange }) => {
  const options = [
    { value: 'AND', label: 'AND' },
    { value: 'OR', label: 'OR' }
  ];

  return (
    <div className={styles.toggleContainer}>
      <div className={styles.label}>Filter Logic:</div>
      <div className={styles.segmentedControl} role="radiogroup" aria-label="Filter Logic">
        {options.map((option) => (
          <label key={option.value} className={`${styles.segment} ${value === option.value ? styles.active : ''}`}>
            <input
              type="radio"
              name="filterLogic"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className={styles.hiddenInput}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
      <div className={styles.helpText}>
        {value === 'AND' ? 'All filters must match' : 'Any filter can match'}
      </div>
    </div>
  );
};

FilterLogicToggle.propTypes = {
  value: PropTypes.oneOf(['AND', 'OR']).isRequired,
  onChange: PropTypes.func.isRequired
};

export default FilterLogicToggle;

